// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"style_containerBox__1XV_V","slide":"style_slide__lNDzb","cartBlogBox":"style_cartBlogBox__2dGK5"};